import React from 'react';
import { BaseIcon } from '../BaseIcon';

export const SignatureColor = (): JSX.Element => <BaseIcon code={'signature-color'} />;
